

const state = {
    alert: {
        visible: false,
        text: ''
    }
}

// getters
const getters = {

    alert: state => {
        return state.alert
    },

}

// actions
const actions = {
    showAlert(context, alert) {
        console.log('AlertsStore > showAlert')
        context.commit('alert', alert)
    },
    clearAlert(context) {
        console.log('AlertsStore > clearAlert')
        context.commit('alert', {visible:false,text:''})
    },
}

// mutations
const mutations = {
    alert (state, alert) {
        state.alert = alert           
    },                  
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/AlertsStore.js